import { useEffect, useState } from 'react'

import { Box, Button, Flex, HStack, Image, ModalCloseButton, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import { LocaleItem, Localization } from '@core/app/types/globalApiType'
import { Locale } from '@core/app/types/profileApiType'
import contactsIcon from '@core/assets/images/mobileheader_contacts.svg'
import homeIcon from '@core/assets/images/mobileheader_home.svg'
import postsIcon from '@core/assets/images/mobileheader_posts.svg'
import newsIcon from '@core/assets/images/newspaper-solid.svg'
import { AppButton } from '@core/components/AppButton'
import { CustomModal } from '@core/components/Modal/Modal'
import { useAppTheme } from '@core/utils/contexts/ThemeContext/ThemeContext'

interface Props {
    locale: Locale
    opened: boolean
    news: boolean | undefined
    signup: boolean | undefined
    contacts: boolean | undefined
    onClose: () => void
    openLang: () => void
}

export const UnauthorizedHeader = ({ opened, news, contacts, signup, onClose, openLang, locale }: Props) => {
    const [isOpened, setIsOpened] = useState(false)
    const { t } = useTranslation()
    const [localization, setLocalization] = useState<Localization>({})
    const { appTheme } = useAppTheme()

    const isEnglishLang = (value: string) => {
        const str = value
        const parts = str.split('(')
        return parts[0] + ' (' + parts[1]
    }

    const webpageUrl = appTheme?.corporation?.Webpage ?? ''

    useEffect(() => {
        setIsOpened(opened)
    }, [opened])

    useEffect(() => {
        if (appTheme && appTheme?.localization) {
            setLocalization(appTheme?.localization)
        }
    }, [appTheme])

    const handleHomeRedirect = () => {
        const url = webpageUrl.includes('http') ? webpageUrl : `https://${webpageUrl}`
        if (webpageUrl.trim().length > 0) {
            window.open(url, '_blank')
        } else {
            window.alert('Webpage is not set')
        }
    }

    const localeList = Object.values(locale?.list || {})

    return (
        <CustomModal
            classNameBody="UnauthorizedHeader"
            toBottom={true}
            isOpen={isOpened}
            isHeaderVisible={false}
            isFooterVisible={false}
            showOverlay={false}
            showFrom={'slideInBottom'}
            onClose={() => onClose()}
            body={
                <Box bg={'bg.1'} borderRadius={'8px 8px 0 0'}>
                    <Flex flexDirection={'column'} w={'full'}>
                        <ModalCloseButton top={4} />
                        {localeList.length > 1 && (
                            <Flex w={'full'} px={4} py={5} borderBottom={'1px solid'} borderColor={'border.1'}>
                                {Object.values(locale?.current || {}).map((flag: LocaleItem) => (
                                    <HStack key={flag.id} cursor={'pointer'} onClick={() => openLang()}>
                                        <Image
                                            maxW={5}
                                            src={
                                                process.env.ENV === 'local'
                                                    ? `${process.env.API_URL}/${flag.flag}`
                                                    : flag.flag
                                            }
                                            alt={flag.name}
                                        />
                                        <Text>
                                            {flag.name.includes('English(US)')
                                                ? isEnglishLang(flag.name)
                                                : `${flag.name}`}
                                        </Text>
                                    </HStack>
                                ))}
                            </Flex>
                        )}
                        {webpageUrl.trim().length > 0 && (
                            <Flex
                                w={'full'}
                                px={4}
                                py={5}
                                borderBottom={'1px solid'}
                                borderColor={'border.1'}
                                gap={3}
                                onClick={handleHomeRedirect}
                            >
                                <Image src={homeIcon} />
                                <Text fontWeight={'medium'} color={'text.secondary'}>
                                    {t('201')}
                                </Text>
                            </Flex>
                        )}
                        <Flex
                            w={'full'}
                            px={4}
                            py={5}
                            borderBottom={'1px solid'}
                            borderColor={'border.1'}
                            gap={3}
                            onClick={() => (location.href = '/jobs')}
                        >
                            <Image src={postsIcon} />
                            <Text fontWeight={'medium'} color={'text.secondary'}>
                                {localization[23] ? localization[23] : t('2495')}
                            </Text>
                        </Flex>
                        {news && (
                            <Flex
                                w={'full'}
                                px={4}
                                py={5}
                                borderBottom={'1px solid'}
                                borderColor={'border.1'}
                                gap={3}
                                onClick={() => (location.href = '/newsfeed')}
                            >
                                <Image src={newsIcon} w="20px" />
                                <Text fontWeight={'medium'} color={'text.secondary'}>
                                    {t('5137')}
                                </Text>
                            </Flex>
                        )}
                        {contacts && (
                            <Flex
                                w={'full'}
                                px={4}
                                py={5}
                                borderBottom={'1px solid'}
                                borderColor={'border.1'}
                                gap={3}
                                onClick={() => (location.href = '/contacts')}
                            >
                                <Image src={contactsIcon} w="20px" />
                                <Text fontWeight={'medium'} color={'text.secondary'}>
                                    {localization[27] ? localization[27] : t('2762')}
                                </Text>
                            </Flex>
                        )}
                        {signup ? (
                            <Flex
                                w={'full'}
                                px={4}
                                py={5}
                                borderBottom={'1px solid'}
                                borderColor={'border.1'}
                                gap={'9px'}
                            >
                                <Button
                                    variant={'secondary'}
                                    w={'calc(50% - 9px)'}
                                    onClick={() => {
                                        location.href = '/login'
                                    }}
                                >
                                    {t('1890')}
                                </Button>
                                <AppButton
                                    translate="no"
                                    variant={'primary'}
                                    w={'calc(50% - 9px)'}
                                    onClick={() => (location.href = '/sign-up')}
                                    title={localization[17] ? localization[17] : t('2496')}
                                />
                            </Flex>
                        ) : (
                            <Flex
                                w={'full'}
                                justifyContent={'center'}
                                px={4}
                                py={5}
                                borderBottom={'1px solid'}
                                borderColor={'border.1'}
                                gap={'9px'}
                            >
                                <Button
                                    variant={'secondary'}
                                    w={'calc(100% - 9px)'}
                                    onClick={() => {
                                        location.href = '/login'
                                    }}
                                >
                                    {t('1890')}
                                </Button>
                            </Flex>
                        )}
                    </Flex>
                </Box>
            }
        />
    )
}
